<div class="payment">
  <app-tips
    *ngIf="error"
    class="block mb-4"
    [icon]="iconType.Information"
    [title]="'checkout.payment.error.title' | translate"
    [tips]="error"
  ></app-tips>
  <div
    class="spinner mx-auto mt-4"
    *ngIf="!showPaymentForm && !freeCheckout"
  ></div>

  <div
    *ngIf="paidBooking"
    id="widget-payment-kit"
    class="widget-payment-kit"
    [class.widget-payment-kit--hidden]="!showPaymentForm"
    style="--credit-card: &quot; {{ creditCardTrans }} &quot;"
  ></div>

  <!-- Submit Form -->
  <div *ngIf="items" class="flex items-center mb-3">
    <app-mobile-fixed-panel [parentElementRef]="elementRef">
      <app-collapse
        *ngIf="isMobileDevice"
        [isCart]="false"
        [title]="'checkout.payment.collapse.opened.text' | translate"
        [closedTitle]="'checkout.payment.collapse.closed.text' | translate"
        buttonExtraClass="justify-between text-vtmn-play-content-brand"
        [iconName]="iconType.ChevronUp"
      >
        <app-checkout-summary
          [items]="items"
          [isVatDisplayed]="true"
          [isCart]="false"
          (submitPromoCode)="clearPromoCode()"
        ></app-checkout-summary>
      </app-collapse>

      <app-form-checkbox
        *ngIf="showPaymentForm"
        class="block mt-4 mb-4"
        [align]="checkboxAlign"
        [label]="legalTermsTranslation"
        (change)="consent = !consent"
      ></app-form-checkbox>

      <button
        app-vtmn-play-button
        type="button"
        id="payment-button"
        [class.w-full]="isMobileDevice"
        [type]="ctaButtonType.Button"
        [disabled]="paymentDisabled"
        [attr.data-disabled]="paymentDisabled"
        [attr.data-loading]="isLoading ? true : null"
        (click)="finishBooking()"
        [size]="buttonSize"
        [shape]="
          isMobileDevice
            ? vtmnPlayButtonShape.SQUARED
            : vtmnPlayButtonShape.ROUNDED
        "
        data-test="submit-payment-form"
      >
        <output *ngIf="isLoading" aria-live="polite" data-part="loading-slot">
          <span
            id=":rk:"
            class="vp-spinner"
            aria-label="Loading..."
            data-part="loading-dots"
          >
            <span></span>
            <span></span>
            <span></span>
          </span>
        </output>
        <span [class.payment-button-text--loading]="isLoading">
          {{ labelButtonTranslation }}
        </span>
      </button>
      <app-modal
        #bookingErrorModal
        class="oneff__modal"
        (modalClose)="closeBookingErrorModal()"
      >
        <span modal-header class="oneff__modal__title">
          {{ 'checkout.payment.oneff.error.title' | translate }}
        </span>

        <div modal-content>
          <p>{{ errorText }}</p>
        </div>
        <div modal-footer class="oneff__modal__footer">
          <button
            class="oneff__modal__footer__close"
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [variant]="vtmnPlayButtonVariant.SECONDARY"
            [shape]="vtmnPlayButtonShape.SQUARED"
            (click)="closeBookingErrorModal()"
          >
            {{ 'checkout.payment.oneff.error.button' | translate }}
          </button>
        </div>
      </app-modal>
    </app-mobile-fixed-panel>
  </div>
</div>
